import { gql } from '@apollo/client';

export const ALERTS_QUERY = gql`
  query alerts {
    alerts {
      alertAddresses
      alertId
      description
      gracePeriod
      renotifyPeriod
      resolutionDelay
      silenced
      silenceComment
      numAlertsInGroup
      trigger
      lastStatus
      history
      parsedTriggerExpressions {
        filter
      }
      parsedPowerQueryExpressions {
        powerQuery
      }
      templateParameters
    }
  }
`;

export const SILENCE_ALERTS_MUTATION = gql`
  mutation silenceAlerts(
    $silenceComment: String
    $silenceConditions: [SilenceConditionInput!]
    $silenceUntil: String!
  ) {
    silenceAlerts(silenceComment: $silenceComment, silenceConditions: $silenceConditions, silenceUntil: $silenceUntil)
  }
`;

export const UNSILENCE_ALERTS_MUTATION = gql`
  mutation unSilenceAlerts($ids: [String!]!) {
    unSilenceAlerts(ids: $ids)
  }
`;

export const CREATE_ALERT = gql`
  mutation CreateAlert($alert: AlertInput!) {
    createAlert(alert: $alert) {
      alertAddresses
      description
      gracePeriod
      renotifyPeriod
      resolutionDelay
      trigger
    }
  }
`;

export const DELETE_ALERT_MUTATION = gql`
  mutation deleteAlert($id: String!) {
    deleteAlert(id: $id)
  }
`;

export const DELETE_ALERTS_MUTATION = gql`
  mutation deleteAlerts($ids: [String!]) {
    deleteAlerts(ids: $ids)
  }
`;

export const UPDATE_ALERT = gql`
  mutation updateAlert($alert: AlertInput!, $id: String!) {
    updateAlert(alert: $alert, id: $id) {
      alertId
      description
      silenced
      history
      trigger
      alertAddresses
      resolutionDelay
      gracePeriod
      renotifyPeriod
    }
  }
`;

export const ALERT_QUERY = gql`
  query alert($id: String!) {
    alert(id: $id) {
      description
      trigger
      silenceComment
      alertAddresses
      resolutionDelay
      renotifyPeriod
      silencedUntilNs
      silenced
      streakStartNs
      lastStatus
      alertId
      gracePeriod
      numAlertsInGroup
      templateParameters
      parsedTriggerExpressions {
        facet
        filter
        fn {
          operator
          param
        }
      }
    }
  }
`;
